<template>
  <div>
    <!-- Overview Cards -->
    <a-row :gutter="[24, 24]" style="margin-top: 24px">
      <!-- <a-col :span="8">
        <a-card
          :bodyStyle="{
            height: '220px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            borderRadius: '8px',
          }"
          style="border-radius: 8px"
          :bordered="true"
        >
          <div
            style="
              font-weight: 600;
              font-size: 16px;
              display: flex;
              align-items: center;
            "
          >
            {{
              mostUsedWarehouse || batchStats.mainWarehouseName || "Warehouse"
            }}
          </div>
          <div
            style="
              color: #888;
              display: flex;
              align-items: center;
              margin-top: 8px;
            "
          >
            <i
              class="fa fa-map-marker-alt"
              style="color: #26a246; margin-right: 8px"
            ></i>
            {{
              (distributionCenters &&
                distributionCenters[0] &&
                distributionCenters[0].address) ||
              "Accra"
            }}
          </div>
          <div style="margin: 12px 0; display: flex; align-items: center">
            <i
              class="fa fa-cubes"
              style="color: #26a246; margin-right: 8px"
            ></i>
            <span
              style="font-size: 24px; font-weight: 700; margin-right: 8px"
              >{{ batchStats.totalUnits || 0 }}</span
            >
            <span style="color: #888"> Units</span>
          </div>
          <div
            style="
              color: #26a246;
              font-weight: 700;
              display: flex;
              align-items: center;
            "
          >
            <i
              class="fa fa-money-bill-wave"
              style="color: #26a246; margin-right: 8px"
            ></i>
            <span style="font-size: medium"
              >GHS
              {{
                batchStats.currentValue
                  ? batchStats.currentValue.toLocaleString()
                  : "0"
              }}</span
            >

            <span style="color: #888; margin-left: 8px; font-size: small">
              Current Value</span
            >
          </div>
          <div style="margin-top: 8px; display: flex; align-items: center">
            <i
              class="fa fa-check-circle"
              style="color: #26a246; margin-right: 8px"
            ></i>
            <a-tag
              :color="
                distributionCenters &&
                distributionCenters[0] &&
                distributionCenters[0].status === 'Active'
                  ? 'green'
                  : 'red'
              "
            >
              {{
                (distributionCenters &&
                  distributionCenters[0] &&
                  distributionCenters[0].status) ||
                "N/A"
              }}
            </a-tag>
          </div>
        </a-card>
      </a-col>
      <a-col :span="8">
        <a-card
          :bodyStyle="{
            height: '220px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }"
          style="border-radius: 8px"
          :bordered="true"
        >
          <div style="height: 100%; width: 100%">
            <l-map
              :zoom="13"
              :center="mostUsedWarehouseCoords"
              style="height: 100%; width: 100%; border-radius: 8px;"
            >
              <l-tile-layer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <l-marker :lat-lng="mostUsedWarehouseCoords" />
            </l-map>
          </div>
        </a-card>
      </a-col> -->
      <a-col :span="8">
        <a-card
          :bodyStyle="{
            height: '220px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }"
          style="border-radius: 8px"
          :bordered="true"
        >
          <div style="font-weight: 600; font-size: 16px; margin-bottom: 8px">
            Quick Stats
          </div>
          <div style="margin-bottom: 8px">
            Total inbound consignments:
            <span style="color: #26a246; font-weight: bold; margin-left: 8px">
              {{ batchStats.totalInboundConsignments || 0 }}
            </span>
          </div>
          <div style="margin-bottom: 8px">
            Active consignments:
            <span style="color: #26a246; font-weight: bold; margin-left: 8px">
              {{ batchStats.activeConsignments || 0 }}
            </span>
          </div>
          <div style="margin-bottom: 8px">
            Allocations:
            <span style="color: #26a246; font-weight: bold; margin-left: 8px">
              {{ batchStats.allocations || 0 }}
            </span>
          </div>
          <div>
            Stock Movement Logs:
            <span style="color: #26a246; font-weight: bold; margin-left: 8px">
              {{ batchStats.stockMovementLogs || 0 }}
            </span>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <div style="margin-top: 32px">
      <!-- Assigned Distribution Centers Table -->
      <div
        style="
          margin: 16px 0px;
          display: flex;
          flex-direction: column;
          gap: 20px;
        "
      >
        <h1 style="margin: 0; font-weight: 800; font-size: 16px">
          Assigned Distribution Centers
        </h1>
        <!-- <a-input
          type="search"
          @input="onDistributionCenterSearch"
          style="width: 50%"
          placeholder="Search centers..."
        >
          <a-icon slot="prefix" type="search" style="color: #ccc" />
        </a-input> -->
      </div>
      <a-table
        :data-source="distributionCenters"
        :loading="loadingDistributionCenters"
        rowKey="id"
        :scroll="{ x: 'max-content' }"
        style="background: #fff; margin-top: 16px"
      >
        <a-table-column title="Center Code" dataIndex="id" key="centerCode" />
        <a-table-column title="Name" dataIndex="name" key="name" />
        <a-table-column
          title="Coverage Area"
          dataIndex="address"
          key="coverageArea"
        />
        <a-table-column title="Capacity" key="capacity">
          <template slot-scope="text, record">
            {{ record.capacity || "N/A" }}
          </template>
        </a-table-column>
        <a-table-column title="Status"  key="status">
          <template slot-scope="text, record">
            <StatusTag :status="record.status" />
          </template>
        </a-table-column>
        <a-table-column title="Actions" key="actions">
          <template slot-scope="text, record">
            <a-button
              type="link"
              icon="eye"
              @click="handleDistributionCenterView(record)"
            />
            <!-- <a-button type="link" icon="edit" @click="handleDistributionCenterEdit(record)" />
            <a-button type="link" icon="delete" @click="handleDistributionCenterDelete(record)" /> -->
          </template>
        </a-table-column>
      </a-table>
    </div>
  </div>
</template>

<script>
// Import map components if needed
// import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
// import "leaflet/dist/leaflet.css";

// import L from "leaflet";
import StatusTag from "../../shared-components/StatusTag.vue";
import sellersService from "../../../api/sellers.service";
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
//   iconUrl: require("leaflet/dist/images/marker-icon.png"),
//   shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
// });

export default {
  name: "StockOverview",
  components: {
    // LMap,
    // LTileLayer,
    // LMarker,
    StatusTag,
  },
  props: {
    sellerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      batchStats: {},
      distributionCenters: [],
      loadingDistributionCenters: false,
      searchQueryDistributionCenters: "",
    };
  },
  computed: {},
  watch: {
    sellerId: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.fetchDistributionCenters();
        }
      },
    },
  },
  methods: {
    async fetchDistributionCenters() {
      if (!this.sellerId) return;
      this.loadingDistributionCenters = true;
      const response = await sellersService.fetchSellerDistributionCenters(this.sellerId);
      this.distributionCenters = response.data?.data?.results || [];
      this.loadingDistributionCenters = false;
    },
  },
};
</script>

<style scoped>
/* Add any styles needed for the overview cards and table */
</style>
